import classnames from "classnames";
import styled from "styled-components";

import { ThemeProps } from "features/common/themes";

import Modal from "../containers/Modal";
import { Props } from "./Modal";
import styles from "./ModalWithTheme.module.scss";

const ThemeWrapper = styled.div`
  ${({ theme }: ThemeProps) => `
   .${styles.theme} {
     background-color: ${theme.foreground};
     }
     `};
`;

export default function ModalWithTheme(props: Props) {
  const { children, className, ...otherProps } = props;

  return (
    <ThemeWrapper>
      <Modal {...otherProps} className={classnames(className, styles.theme)}>
        {children}
      </Modal>
    </ThemeWrapper>
  );
}
